import axios from 'axios';

import type { Guid } from '@apple/utils/primitive';

import { type StoreEventHeaderModel, storeEventHeaderModelSchema } from '../models/heading';

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventHeaderApiController.Get */
export async function getStoreEventHeader(
	storeEventId: Guid,
	signal?: AbortSignal,
): Promise<StoreEventHeaderModel> {
	const response = await axios.get(`api/store-events/${storeEventId}/header`, {
		signal,
	});

	return storeEventHeaderModelSchema.parse(response.data);
}
